import React, { useCallback, useEffect } from 'react';
import Cookie from 'js-cookie';

import usePushDataLayerEvent, { sendConsentEvent } from '../../utils/google-analytics.util';
import { Cookies } from '../../components/modal-cookies/ModalCookies';

const NavigationHandler = ({ children }: { children: React.JSX.Element }) => {
  const { pushDataLayerEvent } = usePushDataLayerEvent();

  const updateConsent = useCallback((cookiesParsed?: Cookies) => {
    if (cookiesParsed) {
      sendConsentEvent(
        {
          ad_storage: cookiesParsed.options.optional ? 'granted' : 'denied',
          ad_user_data: cookiesParsed.options.optional ? 'granted' : 'denied',
          analytics_storage: cookiesParsed.options.optional ? 'granted' : 'denied',
          ad_personalization: cookiesParsed.options.optional ? 'granted' : 'denied',
          functionality_storage: cookiesParsed.options.mandatory ? 'granted' : 'denied',
          personalization_storage: cookiesParsed.options.mandatory ? 'granted' : 'denied',
          security_storage: cookiesParsed.options.mandatory ? 'granted' : 'denied',
        },
        'update',
      );
    }
  }, []);

  useEffect(() => {
    const cookieConfig = Cookie.get('cookie-config');

    if (cookieConfig) {
      const cookiesParsed: Cookies = JSON.parse(cookieConfig);
      updateConsent(cookiesParsed);
    } else {
      updateConsent();
    }
  }, [updateConsent]);

  useEffect(() => {
    const handleAppInstalled = () => {
      pushDataLayerEvent('guardar_pwa', null, 'iniciar-sesion');
    };

    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [pushDataLayerEvent]);

  return <>{children}</>;
};

export default NavigationHandler;
